import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import API_CONSTRUCTOR from '../../models/api-model';
import { toast } from 'sonner';

export const RejectCommitmentDialog = ({ open, onClose, onSuccess, commitmentId }) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!reason.trim()) {
      toast.error('Please provide a reason for rejection');
      return;
    }
    
    try {
      setLoading(true);
      
      const api = API_CONSTRUCTOR();
      await api.put(`/commitments/${commitmentId}/reject`, {
        reason: reason
      });
      
      toast.success('Commitment rejected');
      setReason('');
      onSuccess();
    } catch (err) {
      console.error('Error rejecting commitment:', err);
      toast.error(err.response?.data?.error || 'Failed to reject commitment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Reject Investment Commitment</DialogTitle>
            <DialogDescription>
              This will reject the investor's commitment and notify them. Please provide a clear reason for the rejection.
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Label htmlFor="reason">Reason for Rejection *</Label>
            <Textarea
              id="reason"
              placeholder="Explain why this commitment is being rejected..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="mt-2"
              rows={4}
              required
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading} variant="destructive">
              {loading ? 'Rejecting...' : 'Reject Commitment'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RejectCommitmentDialog;
